function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  className: "nc-icon-wrapper",
  fill: "#fff"
}, React.createElement("path", {
  "data-color": "color-2",
  d: "M15,5H8C7.4,5,7,5.4,7,6v9c0,0.6,0.4,1,1,1h7c0.6,0,1-0.4,1-1V6C16,5.4,15.6,5,15,5z"
}), React.createElement("path", {
  fill: "#fff",
  d: "M5,4c0-0.6,0.4-1,1-1h6V1c0-0.6-0.4-1-1-1H1C0.4,0,0,0.4,0,1v12c0,0.6,0.4,1,1,1h4V4z"
}));

var SvgCopy2 = function SvgCopy2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCopy2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/copy-2.aed28a0d.svg";
export { ForwardRef as ReactComponent };